import {compact} from 'underscore';

import {StageRunSample} from 'workflows/WorkflowConstants';

function _getSampleRowId(sample: {stageRunId: string; stageRunSampleId: string}): string {
  return `${sample.stageRunId}:${sample.stageRunSampleId}`;
}

export function getSelectedSamples(
  orderedSamples: Array<{stageRunId: string; stageRunSampleId: string}>,
  selectedRowIds: {[rowId: string]: boolean}
): Array<{stageRunId: string; stageRunSampleId: string}> {
  const selectedSamples = [];
  for (const sample of orderedSamples) {
    if (selectedRowIds[_getSampleRowId(sample)]) {
      selectedSamples.push(sample);
    }
  }
  return selectedSamples;
}

export function getSelectedSampleIds(
  orderedSamples: Array<{stageRunId: string; stageRunSampleId: string}>,
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample},
  selectedRowIds: {[rowId: string]: boolean}
): Array<string> {
  // StageRunSamples are required to have one of a fileId or batchId. Samples missing both do not exist, so
  // its safe to silently drop them here.
  return compact(
    getSelectedSamples(orderedSamples, selectedRowIds)
      .map((sample) => stageRunSampleById[sample.stageRunSampleId])
      .map((sample) => (sample ? sample.containerId || sample.fileId || sample.batch?.id : null))
  );
}
